<template>
  <v-layout class="align-center justify-center onboarding-form wrap">
    <template v-if="!linkExpired">
        <v-layout class="monthly-payment-wrapper justify-center" style="margin: 0 auto;">
            <v-card style="max-width: 500px; width: 100%;">
                <v-container class="form-container" :class="{'pa-0': $vuetify.breakpoint.xs}">
                    <template v-if="loadingCreditCard">
                        <div class="pa-4">
                            <v-progress-linear
                                indeterminate
                                style="height: 2px;"
                                :color="branding_color"
                            ></v-progress-linear>
                            <div class="text-center pt-3">Please wait...</div>
                        </div>
                    </template>
                    <template v-else>
                        <v-flex v-if="!no_data.includes(logo) && show_logo" class="xs12 mr-2 mb-0 px-4 pt-3 text-left">
                            <div>
                                <a v-if="!no_data.includes(website)" target="_blank" :href="website">
                                    <img :src="logo" style="max-height: 50px; max-width: 100%;" class="pointer" alt="Organization Logo">
                                </a>
                                <img v-else :src="logo" style="max-height: 50px; max-width: 100%;" alt="Organization Logo">
                            </div>
                        </v-flex>
                        <template v-if="!completedSuccessfully">
                            <v-card-title class="px-4 pb-1">
                                <h2 class="title">{{ `Add Credit Card${ !no_data.includes(clientName) ? ' for ' + clientName : ''}` }}</h2>
                            </v-card-title>
                            <div class="caption px-4">This card will be used for your payments.</div>
                            <v-layout wrap>
                            <v-card-text class="flex" style="max-width: 460px; margin: 0 auto;">
                                <card-form
                                    ref="child"
                                    @focus="resetServerValidation"
                                    @resetServer="resetServerValidation"
                                    @token="submitCard($event)"
                                    @state="stripe_state = $event"
                                    :processor="processor"
                                ></card-form>
                                <v-alert
                                    class="pa-2 mt-4"
                                    :value="
                                        stripe_state.cardErrorMessage.length > 0 ||
                                        stripe_state.nameErrorMessage.length > 0 ||
                                        stripe_state.postalErrorMessage.length > 0
                                    " outlined
                                    color="error"
                                    icon="priority_high"
                                    transition="scale-transition">
                                    <span class="caption">Please fill out all fields correctly</span>
                                </v-alert>
                                <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                                    <span class="caption">{{ serverValidationMessage }}</span>
                                </v-alert>
                                <v-flex xs12 sm12 md12 lg12>
                                <v-btn :disabled="loading" :loading="loading" class="sub-button" :color="branding_color" @click="submit" data-test="submitButton">Add Card</v-btn>
                                </v-flex>
                            </v-card-text>
                            </v-layout>
                        </template>
                        <template v-else>
                            <v-card-title class="px-4 pb-1">
                                <h2 class="title">Thank you!</h2>
                            </v-card-title>
                            <div class="px-4 pb-4">Your card has been successfully added.</div>
                        </template>
                    </template>
                </v-container>
            </v-card>
        </v-layout>
    </template>
    <template v-else>
        <v-flex class="onboarding-inactive">
            <v-card class="pa-4 pa-sm-8">
            <div class="text-center mb-4">
                <img :src="onboarding_inactive" style="maxWidth: 170px;" alt="Sorry, this link has expired"/>
            </div>
            <div class="text-center">
                <h2 class="title">Sorry, this link has expired.</h2>
                <div class="body-2">The link is active for 24 hours after generation. Please request a new link.</div>
            </div>
            </v-card>
        </v-flex>
    </template>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import CardForm from './CardForm/CardForm.vue'
import ApiService from "@/common/api.service"
import { mapGetters, mapActions, mapMutations } from "vuex"

    export default {
        name: 'PublicCreditCard',
        components: {
            'card-form': CardForm
        },
        data() {
            return {
                no_data: [null, '', undefined, 'null'],
                loading:false,
                onboarding_inactive: require('@/assets/img/onboarding-inactive.svg'),

                serverValidation: true,
                serverValidationMessage: 'Oops something went wrong...',
                server_errors: {},

                loadingOrganization: false,
                branding_color: "#e8e8e8",
                organization_status: null,
                charges_enabled: false,
                processor: null,
                stripe_state: {
                    cardErrorMessage: '',
                    nameErrorMessage: '',
                    postalErrorMessage: '',
                    complete: false
                },
                completedSuccessfully: false,
                clientName: null,
                loadingCreditCard: false,
                linkExpired: false,
            }
        },
        mounted() {
            this.getOrganization()
            this.getCreditCard()
        },
        methods: {
            ...mapActions(['branding', 'vEmit']),
            ...mapMutations(['logOut']),
            getCreditCard () {
              this.completedSuccessfully = false
              if (!this.no_data.includes(this.$route.params.id)) {
                this.loadingCreditCard = true
                ApiService.put('/private_credit_card/info', { link_id: this.$route.params.id })
                  .then(response => {
                    if (
                        !this.no_data.includes(response) &&
                        !this.no_data.includes(response.data) &&
                        !this.no_data.includes(response.data.client_name)
                    ) {
                        this.clientName = response.data.client_name
                        if (
                            !this.no_data.includes(this.user) &&
                            !this.no_data.includes(this.user.full_name) &&
                            this.clientName !== this.user.full_name
                        ) {
                            this.logOut()
                        }
                    }
                    this.loadingCreditCard = false
                  })
                  .catch(error => {
                    this.linkExpired = true
                    console.log(error)
                    this.loadingCreditCard = false
                  })
              }
            },
            getOrganization() {
                this.loadingOrganization = true
                if(!this.no_data.includes(this.state_branding_color)) {
                    this.branding_color = this.state_branding_color
                }
                this.branding({"organization":this.organization})
                    .then(response => {
                        if(!this.no_data.includes(response.organization.branding_color)) {
                            this.$vuetify.theme.themes.light.branding = response.organization.branding_color
                        }
                        if(
                            !this.no_data.includes(response.organization) &&
                            !this.no_data.includes(response.organization.card_connect_site)
                        ) {
                            this.processor = 'card_connect'
                        } else {
                            this.processor = 'stripe'
                        }
                        this.branding_color = this.$vuetify.theme.themes.light.branding
                        this.loadingOrganization = false
                        this.organization_status = response.organization.organization_status
                        this.charges_enabled = response.organization.charges_enabled
                    })
                    .catch(error => {
                        console.log(error)
                        this.loadingOrganization = false
                    })
            },
            askForStripeToken() {
                this.vEmit({ name: 'gaveMeToken' })
            },
            submit() {
                this.resetServerValidation()
                this.askForStripeToken()
                if(this.stripe_state.complete) {
                    this.loading = true
                }
            },
            submitCard(token) {
                let url = '/private_credit_card/create_card';
                let data = { link_id:  this.$route.params.id }
                if(token.error === undefined) {
                    this.resetServerValidation()
                    data = { ...data, ...token }
                    ApiService.put(url, data)
                        .then(response => {
                            this.completedSuccessfully = true
                        })
                        .catch(({ response }) => {
                            this.loading = false
                            this.serverValidation = false
                            if (response.data.error) { this.serverValidationMessage = this.titleCase(response.data.error)}
                            if (response.data.message) { this.serverValidationMessage = this.titleCase(response.data.message)}
                            if (response.data.errors) { this.server_errors = response.data.errors }
                        })
                } else {
                    this.loading = false
                    if(token.error && token.error.message) { 
                        this.serverValidation = false
                        this.serverValidationMessage = token.error.message
                    }
                    return
                }
            },
            titleCase(str = ''){
                return _.startCase(str.replace(/_/g, ' '));
            },
            resetServerValidation() {
                this.serverValidation = true
                this.serverValidationMessage = 'Oops something went wrong...'
                this.server_errors = {}
            }
        },
        computed: {
            ...mapGetters({
                user: 'currentUser',
                state_branding_color: 'brandingColor',
                activeOnboarding: 'activeOnboarding',
                show_logo: 'showLogo',
                logo: 'logo',
                website: 'website'
            }),
            organization: function() {
                return  this.$route.params.organization
            }
        }
    }
</script>

<style scoped>
.onboarding-form {
    margin-bottom: 80px;
}

.theme--light .v-toolbar {
    background-color: #00838F;
    color: rgb(255, 255, 255);
}
.application .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat),
.theme--light .v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #00838F;
    color: white;
    padding: 0;
}
@media screen and (max-width: 600px) {
    .form-toolbar .v-toolbar__title {
        font-size: 1.75em;
        text-align: left;
        padding: 0 15px;
        margin-left: 0;
    }
}

.form-container{
    max-width: 672px!important;
}

.monthly-payment-wrapper .sub-button{
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    color: white;
    flex: 1;
    margin: 6px 0;
    width: 100%;
    text-align: center;
    padding: 15px;
    font-weight: 300;
    font-size: 16px;
    text-transform: uppercase;
    height: 44px;
    padding: 12px;

}
</style>

<style>
.onboarding-inactive {
    max-width: 500px;
}
.onboarding-form .v-toolbar {
    height: auto!important;
}
.onboarding-form .v-toolbar .v-toolbar__content{
    height: auto!important;
}
.v-toolbar__title{
    white-space: unset;
}
.monthly-payment-wrapper .form-toolbar .v-toolbar__content {
    height: auto!important;
}
</style>
